import { RotateCcw, AlertTriangle, Info } from "lucide-react";

const inputCls = "w-full px-3 py-2 bg-white border border-stone-300 rounded-lg text-sm text-stone-900 focus:outline-none focus:border-stone-900 transition-colors";

function Field({ meta, value, onChange, fit, note }) {
  const Tag = meta.multiline ? "textarea" : "input";
  return (
    <label className="block" data-testid={`poster-field-${meta.key}-wrap`}>
      <span className="block text-xs font-semibold text-stone-700 mb-1">{meta.label}</span>
      <Tag
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={meta.multiline ? (meta.key === "description" ? 3 : 2) : undefined}
        data-testid={`poster-field-${meta.key}`}
        className={`${inputCls} ${fit && !fit.ok ? "border-red-500 focus:border-red-600" : ""} ${meta.multiline ? "resize-y" : ""}`}
      />
      {fit && !fit.ok && (
        <span className="mt-1 flex items-start gap-1.5 text-xs text-red-700" data-testid={`poster-field-${meta.key}-error`}>
          <AlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0" /> {fit.message}
        </span>
      )}
      {fit?.ok && value && fit.size && (
        <span className="mt-1 block text-[10px] text-stone-400" data-testid={`poster-field-${meta.key}-size`}>Fits at {fit.size}pt</span>
      )}
      {!value && note && (
        <span className="mt-1 flex items-start gap-1.5 text-xs text-amber-800" data-testid={`poster-field-${meta.key}-note`}>
          <Info className="w-3.5 h-3.5 mt-0.5 shrink-0" /> {note}
        </span>
      )}
    </label>
  );
}

function Section({ title, action, children, testid }) {
  return (
    <section className="bg-white border border-stone-200 rounded-xl p-5 space-y-3" data-testid={testid}>
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-[10px] uppercase tracking-[0.2em] font-bold text-stone-500">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}

function ResetBtn({ onClick, label, testid }) {
  return (
    <button type="button" onClick={onClick} data-testid={testid}
      className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-stone-600 hover:text-stone-950 transition-colors">
      <RotateCcw className="w-3 h-3" /> {label}
    </button>
  );
}

export function PosterForm({ fields, values, setField, fits, notes, onResetFranchise, onResetDescription, hasDefaultDescription }) {
  const fitFor = (k) => (fits || []).find((f) => f.key === k);
  const render = (m) => <Field key={m.key} meta={m} value={values[m.key] || ""} onChange={(v) => setField(m.key, v)} fit={fitFor(m.key)} note={notes?.[m.key]} />;
  return (
    <div className="space-y-4" data-testid="poster-form">
      <Section title="Franchise heading" testid="poster-section-heading"
        action={<ResetBtn onClick={onResetFranchise} label="Reset to franchise details" testid="poster-reset-franchise" />}>
        {fields.filter((m) => m.section === "heading").map(render)}
      </Section>
      <Section title="Project description" testid="poster-section-description"
        action={hasDefaultDescription ? <ResetBtn onClick={onResetDescription} label="Reset description" testid="poster-reset-description" /> : null}>
        {fields.filter((m) => m.section === "description").map(render)}
      </Section>
      <Section title="Contact details" testid="poster-section-contact">
        {fields.filter((m) => m.section === "contact").map(render)}
      </Section>
    </div>
  );
}
